import { render, staticRenderFns } from "./StarSvg.vue?vue&type=template&id=7fb08331&"
import script from "./StarSvg.vue?vue&type=script&lang=js&"
export * from "./StarSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports